<template>
  <v-container fluid class="pa-0 ma-3">
    <v-btn
      class="ma-2"
      @click="exportToExcel"
      append-icon="mdi-file-excel"
      variant="outlined"
      >Excel</v-btn
    >
    <v-btn
      class="ma-2"
      @click="print"
      append-icon="mdi-printer"
      variant="outlined"
      >print</v-btn
    >

    <v-container>
      <v-text-field
        control-variant="default"
        type="numeric"
        rounded
        label="حد الرصيد"
        v-model="balance_limit"
      ></v-text-field>
    </v-container>
    <v-container>
      <v-div id="printArea" dir="rtl">
        <v-data-table
          v-model="selected"
          :items="filteredCustomers"
          :headers="headers"
        >
          <template v-slot:no-data>
            <h3>No data available</h3>
          </template>
        </v-data-table>
      </v-div>
    </v-container>
  </v-container>
  <overlay-loader v-model="loading" />
</template>

<script>
//import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

import * as XLSX from "xlsx";
import { api } from "@/plugins/api";

export default {
  components: {
    OverlayLoader,
  },
  data: () => ({
    balance_limit: 15000,
    headers: [
      { title: "الاسم", key: "customer.name" },
      { title: "الجوال", key: "customer.phone" },
      { title: "الرصيد", key: "last_action.current_balance" },
      { title: "رقم العداد", key: "customer.meters[0].code" },
      { title: " العلبة", key: "customer.meters[0].parent.name" },
    ],
    loading: false,
    dialog: false,
    customers_data: [],
  }),
  computed: {
    customers() {
      //return repo.customers.getAllCustomers();
      return this.customers_data;
    },
    filteredCustomers() {
      //return this.customers;
      try {
        return this.customers.filter(
          (customer) =>
            Math.abs(customer.last_action.current_balance) >=
            Math.abs(this.balance_limit)
        );
      } catch (error) {
        console.log(error);
        return 1;
      }
    },
    dataToExport() {
      const res = this.customers.map(({ customer, last_action }) => {
        return {
          name: customer.name,
          phone: customer.phone,
          balance: last_action.current_balance,
        };
      });
      return res;
    },
  },
  methods: {
    exportToExcel() {
      // Create a worksheet from the data
      const worksheet = XLSX.utils.json_to_sheet(this.dataToExport);

      // Create a new workbook
      const workbook = XLSX.utils.book_new();

      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Export the workbook to a file
      XLSX.writeFile(workbook, "data.xlsx");
    },
    print() {
      const printElement = document.getElementById("printArea");
      if (!printElement) {
        console.error("Element not found");
        return;
      }

      const printContent = printElement.innerHTML;
      const printWindow = window.open("", "_blank", "width=800,height=600");

      printWindow.document.write(`
    <html>
        <head>
            <title>Print Content</title>
            <style>
                @media print {
                    body {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 0;
                        height: 100vh;  /* Ensure the body takes full height */
                        padding: 20px;
                        box-sizing: border-box; /* Include padding in width calculations */
                    }
                    @page {
                        margin: 0;
                    }
                }
            </style>
        </head>
        <body dir=rtl>
            ${printContent}
        </body>
    </html>
`);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    },

    async fetch() {
      this.loading = true;

      try {
        //const res = await repo.customers.fetchAll();
        //console.log("res", res);
        const response = await api.get(`/reports/customers_should_pay`);
        const res = response.data.data;
        console.log("response", res);
        this.customers_data = res;
        //this.customers = response.data.data;
        if (res) {
          //
        }
      } catch (error) {
        swalFun.fail("error");
      }

      this.loading = false;
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
